/**
 * Compliance footer mounted on auth pages (/login, /set-password) which render
 * outside PortalLayout. Surfaces MARN, agent name, legal entity and links to
 * Privacy + MARA Code of Conduct, satisfying Migration Agents Code of Conduct
 * reg. 25(2) for website-page MARN display.
 */
export default function AuthFooter() {
  return (
    <div className="mt-8 text-center text-[11px] leading-relaxed text-slate-400">
      <div>
        ADI Immigration · A service of Partner Visa Australia Pty Ltd · ABN 97 670 826 892
      </div>
      <div>Ilya Eli Bekker, Registered Migration Agent · MARN 1465541</div>
      <div className="mt-1 space-x-2">
        <a
          href="https://adiimmigration.com.au/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Privacy Policy
        </a>
        <span aria-hidden="true">·</span>
        <a
          href="https://www.mara.gov.au/tools-for-registered-agents/code-of-conduct"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          MARA Code of Conduct
        </a>
      </div>
    </div>
  );
}
